module.exports = __webpack_public_path__ + "static/media/Allison Leeds.8fedc47e.png";